import { memo } from "react";

import { AD_SIZES } from "./constants";

import styles from "./injector-ad.module.css";
/**
 * Standard full-width ad
 *
 * @param {{
 *    position: string,  // Unique ID on page to allow adops to target specific positions
 *    margin: boolean,   // Disable when pressed against a shaded background
 *  }} props
 */
function InjectorAd({ position = null, margin = true, shade = true }) {
  return (
    <div className={styles.breakoutContainer} suppressHydrationWarning={true}>
      <gpt-ad
        // Since this is a fake element, we don't use className
        // https://react.dev/reference/react-dom/components#custom-html-elements
        class={styles.ad}
        unitpath="injector"
        style={{
          "--margin": margin ? "0.25rem 0 1.25rem" : 0,
          "--ad-background-color": shade ? null : "transparent",
        }}
        // Theory of sizes: if it fits, it ships, may the highest price size win
        // Some mobile-specific formats on mobile
        // In the rare event DFP thinks the best thing to serve on desktop is a box,
        // trust the algorithm and serve a box.
        id-format={AD_SIZES.INJECTOR.idFormat}
        {...AD_SIZES.INJECTOR.props}
        targeting-pos={position}
      ></gpt-ad>
    </div>
  );
}

// Never allow re-rendering
export default memo(InjectorAd);
